/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Finish_HintInputs */



/**
* | output |
* | --- |
* | "Leave empty for ongoing league" |
*
* @param {League_Finish_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_finish_hint = /** @type {((inputs?: League_Finish_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Finish_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Laisser vide pour une ligue en cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dejar vacío para liga en curso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deixar vazio para liga em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lasciare vuoto per campionato in corso")
	return /** @type {LocalizedString} */ ("Leave empty for ongoing league")
});